import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Isotipo from "@/components/Isotipo";
import { VARIANTS } from "./data";

const mont = { fontFamily: "Montserrat, sans-serif" };
const body = { fontFamily: "Manrope, sans-serif" };

const swatches = {
  "/v1": ["#171726", "#26775e", "#edaa51"],
  "/v2": ["#FBF9F5", "#1E5846", "#D8963E"],
  "/v3": ["#171726", "#F8F8F6", "#edaa51"],
};

const MockupIndex = () => {
  return (
    <div data-testid="mockup-index" className="min-h-screen" style={{ backgroundColor: "#0f0f17", color: "#F4F4F5", ...body }}>
      <div className="max-w-5xl mx-auto px-6 py-20">
        <div className="flex items-center gap-2.5 mb-16">
          <Isotipo className="w-6 h-6" fill="#edaa51" />
          <span className="text-lg font-extrabold tracking-tight" style={mont}>GRABARTE</span>
        </div>

        <p className="text-xs uppercase tracking-[0.3em] mb-6" style={{ ...mont, color: "#26775e" }}>Propuesta de rediseño · 3 direcciones</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight max-w-2xl" style={mont}>Una versión más limpia. Elige tu dirección.</h1>
        <p className="mt-6 text-lg max-w-xl" style={{ color: "#A1A1AA" }}>
          Tres mockups con el mismo contenido real, menos densidad y una escala tipográfica contenida.
          Ábrelos, compáralos y dime cuál seguimos desarrollando para toda la web.
        </p>

        <div className="mt-16 grid sm:grid-cols-3 gap-6">
          {VARIANTS.map((v) => (
            <Link
              key={v.route}
              to={v.route}
              data-testid={`open-${v.route.replace("/", "")}`}
              className="group rounded-xl p-6 transition-all duration-300"
              style={{ backgroundColor: "#17171f", border: "1px solid rgba(255,255,255,0.08)" }}
            >
              <div className="flex gap-2 mb-6">
                {swatches[v.route].map((c, i) => (
                  <span key={i} className="w-8 h-8 rounded-full" style={{ backgroundColor: c, border: "1px solid rgba(255,255,255,0.12)" }} />
                ))}
              </div>
              <p className="text-[11px] uppercase tracking-[0.2em] mb-2" style={{ ...mont, color: "#edaa51" }}>{v.route.replace("/", "").toUpperCase()}</p>
              <h3 className="text-xl font-bold tracking-tight" style={mont}>{v.name}</h3>
              <p className="mt-2 text-sm leading-relaxed" style={{ color: "#A1A1AA" }}>{v.desc}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] transition-colors group-hover:text-[#edaa51]" style={mont}>
                Ver mockup <ArrowRight size={14} />
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-16 pt-8" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
          <Link to="/" data-testid="back-to-current" className="inline-flex items-center gap-2 text-sm font-semibold" style={{ ...mont, color: "#A1A1AA" }}>
            <ArrowRight size={14} className="rotate-180" /> Volver al sitio actual
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MockupIndex;
